export default __webpack_public_path__ + "static/media/X33-Mall_small.0bcc8b8c.jpg";